require('./RAFundTransferNotification.scss');

//@vendors
const React = require('react');
const classnames = require('classnames');
const PropTypes = require('prop-types');

//@commons
const { OKButton } = require('commonsComponents/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constant
const {
    RA_FUND_TRANSFER_STEP1,
    RA_FUND_TRANSFER_TOTAL_STEPS,
    RA_FUND_TRANSFER_STEP3,
} = require('../../raConstants/index');

class RAFundTransferNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openFundTransferInfo: false,
        };

        this.handleSinglePortfolioClose = this.handleSinglePortfolioClose.bind(
            this,
        );
    }

    handleSinglePortfolioClose() {
        const {
            currentStep,
            closeNotification,
            disableNotification,
            portfolioId,
            onClose,
        } = this.props;
        closeNotification(portfolioId);
        if (currentStep === RA_FUND_TRANSFER_STEP3) {
            disableNotification(portfolioId);
        }
        onClose();
    }

    createCloseButton() {
        const { forSinglePortfolio, onClose } = this.props;
        const onCloseClick = forSinglePortfolio
            ? this.handleSinglePortfolioClose
            : onClose;
        return (
            <span className="ra-fund-trasnfer-notification__close-button">
                <OKButton modifier="link-ghost" onClick={onCloseClick}>
                    <i className="icon icon-cerrar ra-fund-trasnfer-notification__close-button-icon" />
                </OKButton>
            </span>
        );
    }

    createProgressIndicator() {
        const { currentStep } = this.props;
        const progressSteps = [
            'icon-transferir',
            'icon-carteras-tower',
            'icon-fondos-planes-seguros',
        ];

        return progressSteps.map((iconClass, index) => {
            const stepIconClasses = classnames(
                'icon ra-fund-trasnfer-notification__progress-step-icon',
                {
                    [iconClass]: index >= currentStep,
                    'icon-checkmark  ra-fund-trasnfer-notification__progress-step-icon--done':
                        index < currentStep,
                    'ra-fund-trasnfer-notification__progress-step-icon--active':
                        index === currentStep,
                },
            );

            const stepClasses = classnames(
                'ra-fund-trasnfer-notification__progress-step',
                {
                    'ra-fund-trasnfer-notification__progress-step--active':
                        index < currentStep,
                },
            );

            return (
                <div className={stepClasses} key={index}>
                    <i className={stepIconClasses} />
                </div>
            );
        });
    }

    createProgressParagraphs() {
        const { currentStep } = this.props;
        const progressStepParagraphs = [
            'fundTransferNotification-fundTransferNotification_step1Text',
            'fundTransferNotification-fundTransferNotification_step2Text',
            'fundTransferNotification-fundTransferNotification_step3Text',
        ];

        return progressStepParagraphs.map((value, index) => {
            const paragraphClasses = classnames(
                'ra-fund-trasnfer-notification__progress-paragraph',
                {
                    'ra-fund-trasnfer-notification__progress-paragraph--active':
                        index === currentStep,
                    'ra-fund-trasnfer-notification__progress-paragraph--done':
                        index < currentStep,
                },
            );

            return (
                <FormattedText
                    className={paragraphClasses}
                    value={value}
                    key={index}
                />
            );
        });
    }

    createSinglePortfolioNotification() {
        const closeButton = this.createCloseButton();
        const progressIndicator = this.createProgressIndicator();
        const progressParagraphs = this.createProgressParagraphs();

        return (
            <div className="ra-fund-trasnfer-notification">
                <h2 className="ra-fund-trasnfer-notification__title">
                    <FormattedText value="fundTransferNotification-fundTransferNotification_title" />
                </h2>
                <div className="ra-fund-trasnfer-notification__progress-wrapper">
                    {progressIndicator}
                </div>
                <div className="ra-fund-trasnfer-notification__progress-paragraph-wrapper">
                    {progressParagraphs}
                </div>
                <div className="ra-fund-trasnfer-notification__movement-link">
                    <OKLink
                        modifier="complementary"
                        to={this.props.movementLink}
                    >
                        <FormattedText value="fundTransferNotification-fundTransferNotification_orderAndMovementsLink" />
                    </OKLink>
                </div>
                {closeButton}
            </div>
        );
    }

    createSinglePortfolioNotificationCC() {
        const { currentStep, userName } = this.props;
        const stepNumber = currentStep + 1;
        const closeButton = this.createCloseButton();

        return (
            <BlockInfo extraClass="ra-fund-trasnfer-notification__block-containt">
                <FormattedText value="cc_fundTransferNotification-mandatoryReadingText" />
                <h2 className="ra-fund-trasnfer-notification__title--cc">
                    <FormattedText
                        value="cc_fundTransferNotification-title"
                        injectedStrings={[userName]}
                    />
                </h2>
                <div>
                    <FormattedText
                        className="ra-fund-trasnfer-notification__step-text"
                        value="cc_fundTransferNotification-stepLabel"
                        injectedStrings={[
                            stepNumber,
                            RA_FUND_TRANSFER_TOTAL_STEPS,
                        ]}
                    />
                    <FormattedText
                        className="ra-fund-trasnfer-notification__step-text"
                        value={`cc_fundTransferNotification-step${stepNumber}Title`}
                    />
                    <FormattedText
                        value={`cc_fundTransferNotification-step${stepNumber}Description`}
                    />
                </div>
                <div className="ra-fund-trasnfer-notification__movement-link ra-fund-trasnfer-notification__movement-link--left-align">
                    <OKLink
                        modifier="complementary"
                        to={this.props.movementLink}
                    >
                        <FormattedText value="fundTransferNotification-fundTransferNotification_orderAndMovementsLink" />
                    </OKLink>
                </div>
                {closeButton}
            </BlockInfo>
        );
    }

    createMultiplePortfolioNotification() {
        return (
            <OKMessage
                type="informative"
                modifier="dark-bg"
                closeButton={true}
                onCloseButtonClick={this.props.onClose}
            >
                <h2 className="ra-fund-trasnfer-notification__title--multiple-notification">
                    <FormattedText value="fundTransferNotification-fundTransferNotification_multipleNotificationTitle" />
                </h2>
                <FormattedText value="fundTransferNotification-fundTransferNotification_multipleNotificationParagraph" />
            </OKMessage>
        );
    }

    createMultiplePortfolioNotificationCC() {
        const closeButton = this.createCloseButton();

        return (
            <BlockInfo extraClass="ra-fund-trasnfer-notification__block-containt">
                <FormattedText value="cc_fundTransferNotification-mandatoryReadingText" />
                <h2 className="ra-fund-trasnfer-notification__title--cc">
                    <FormattedText
                        value="cc_fundTransferNotification-titleMultiple"
                        injectedStrings={[this.props.userName]}
                    />
                </h2>
                <FormattedText
                    className="ra-fund-trasnfer-notification__block-containt"
                    value="cc_fundTransferNotification-multipleDescription"
                />
                {closeButton}
            </BlockInfo>
        );
    }

    render() {
        const { forSinglePortfolio } = this.props;

        let content, contentCC;
        if (forSinglePortfolio) {
            content = this.createSinglePortfolioNotification();
            contentCC = this.createSinglePortfolioNotificationCC();
        } else {
            content = this.createMultiplePortfolioNotification();
            contentCC = this.createMultiplePortfolioNotificationCC();
        }

        return (
            <React.Fragment>
                <WebappRender>{content}</WebappRender>
                <ContactCenterRender>{contentCC}</ContactCenterRender>
            </React.Fragment>
        );
    }
}

RAFundTransferNotification.propTypes = {
    closeNotification: PropTypes.func,
    currentStep: PropTypes.number,
    disableNotification: PropTypes.func,
    forSinglePortfolio: PropTypes.bool,
    movementLink: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    portfolioId: PropTypes.string,
    userName: PropTypes.string.isRequired,
};

RAFundTransferNotification.defaultProps = {
    currentStep: RA_FUND_TRANSFER_STEP1,
    forSinglePortfolio: true,
};

module.exports = RAFundTransferNotification;
